import styled from 'styled-components';

const ValueContainer = styled.div`
  width: 100%;
  height: 38px;
`;

export default ValueContainer;
